.border__radius__lg {
  border-radius: var(--border-radius-lg);
}

.border__light__gray {
  border: 1px solid var(--colors-grays-ultralight);
}

/* Increasing selector specificity */
div.icon__xs {
  height: 12px;
  width: 12px;
}

.opacity__not__unlocked {
  opacity: 0.3;
}

.white__space__no__wrap {
  white-space: nowrap;
}

.header__border {
  border-radius: 24px 24px 0 0;

  &:last-child {
    border-radius: 24px;
  }
}

.content__border {
  border-top: none;
  border-bottom: none;

  &:last-of-type {
    border-bottom: 1px solid var(--colors-transparent-black-ten);
    border-radius: 0 0 24px 24px;
  }
}

.footer__border {
  border-radius: 0 0 24px 24px;
}

.live__region {
  display: contents;
}

.header__image {
  max-height: 283px;
}

@media (--reefer-media-desktop-sm-min) and (height <= 800px) and (hover: hover) {
  .header__image {
    max-height: 150px;
  }
}
